import theme from '../../base';

const price = {
  foregroundSecondInfo: theme.colors.neutrals.gray700,
  foregroundGrayscaledInfo: theme.colors.neutrals.gray700,
  foregroundPrimaryInfo: theme.colors.blues.blue800,
};

export default price;
